<div class="row" data-testid="all-strikes-div">
    <hr />
    <div class="panel panel-primary">
        <div class="panel-heading clearfix">
            <h4 class="panel-title pull-left" style="padding-top: 7.5px;">UniteHERE Strikes</h4>
            <div class="input-group">
                <input id="inputSearchStrikes" data-testid="strikes-search-box" type="search" [(ngModel)]="filterStrikes" class="form-control shortInputSearch" placeholder="Filter, search strikes.." (keyup.enter)="search(0)">
                <div class="input-group-btn">
                    <button class="btn btn-primary" data-testid="strikes-search-button" (click)="search(0)" ><i class="glyphicon glyphicon-search"></i></button>
                    <button class="btn btn-primary" data-testid="strikes-clear-button" (click)="clearSearch();"><i class="glyphicon glyphicon-remove-sign"></i></button>
                </div>
            </div>
        </div>
        <div class="panel-body">
            <div class="row">
                <div class="col-xs-12 col-sm-6 col-md-4" *ngFor="let strike of strikes">
                    <div class="media">
                        <div class="media-body">
                            <a  routerLink="/strikes/{{strike.ID}}" title="View {{strike.Title}} details"> 
                                <h4 class="media-heading">{{strike.Title}}</h4>
                            </a>
                            <br />
                            Start Date: <strong>{{strike.StartDate | date:"MM/dd/yyyy"}}</strong>
                            <br />
                            <div *ngIf="strike.EndDate">Ended On: <strong>{{strike.EndDate | date:"MM/dd/yyyy"}}</strong><br /></div>
                            <br />
                        </div>
                        <div class="media-bottom">
                            Min Threshold Time(in Hours): <strong>{{strike.MinThresholdHours}}</strong><br />
                            Min Threshold Days: <strong>{{strike.MinThresholdDays}}</strong><br />
                            Participation Benefit Amount: <strong>{{strike.ParticipationBenefitAmt | currency:'USD':'symbol':'1.0-0'}}</strong><br />
                            Helper Benefit Amount : <strong> {{strike.HelperBenefitAmt | currency:'USD':'symbol':'1.0-0'}} </strong><br />
                            <br />
                            <strong class="label label-info">Last Week</strong><br />
                            Min Threshold (Hours): <strong>{{strike.LastWeekMinThresholdHours}}</strong><br />
                            Min Threshold Days: <strong>{{strike.LastWeekMinThresholdDays}}</strong><br />
                            Participation Benefit: <strong>{{strike.LastWeekParticipationBenefitAmt | currency:'USD':'symbol':'1.0-0'}}</strong><br />
                            Helper Benefit: <strong>{{strike.LastWeekHelperBenefitAmt | currency:'USD':'symbol':'1.0-0'}}</strong>
                        </div>
                    </div>
                    <br /><br />
                </div>
            </div>
        </div>
        <div class="panel-footer">
            <div class="text-center">
                <app-custom-pager [page]="page" [pagesCount]="pagesCount" (pageChange)="search($event)"></app-custom-pager>
            </div>
        </div>
    </div>
</div>
